import { Injectable } from "@angular/core";
import { environment } from "../environments/environment";

@Injectable()
export class SessionStorageService {
  constructor() {}

  private __get(key: string) {
    return JSON.parse(localStorage.getItem(key));
  }

  private __set(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  getToken() {
    return this.__get(environment.token);
  }

  setToken(value) {
    this.__set(environment.token, JSON.stringify(value));
  }

  getCpf() {
    return this.__get("user_cpf");
  }

  setCpf(value) {
    this.__set("user_cpf", JSON.stringify(value));
  }

  getUserId() {
    return this.__get(environment.idKey);
  }

  setUserId(value) {
    this.__set(environment.idKey, JSON.stringify(value));
  }

  getUserName() {
    return this.__get("user_name");
  }

  setUserName(value) {
    this.__set("user_name", JSON.stringify(value));
  }

  getEmail() {
    return this.__get("user_email");
  }

  setEmail(value) {
    this.__set("user_email", JSON.stringify(value));
  }

  getUserGroupId() {
    return this.__get("group_id");
  }

  setUserGroupId(value) {
    this.__set("group_id", JSON.stringify(value));
  }

  getUserGroup() {
    return this.__get("user_group");
  }

  setUserGroup(value) {
    this.__set("user_group", JSON.stringify(value));
  }

  setContactLink(link) {
    this.__set("contact_link", link);
  }

  getContactLink() {
    return localStorage.getItem("contact_link");
  }

  setOriginSimulation(origin) {
    this.__set("origin_simulation", origin);
  }

  getOriginSimulation() {
    return localStorage.getItem("origin_simulation");
  }

  clear() {
    // localStorage.removeItem(environment.token);
    // localStorage.removeItem(environment.idKey);
    // localStorage.removeItem('user_cpf');
    // localStorage.removeItem('user_email');
    // localStorage.removeItem('group_id');
    // localStorage.removeItem('user_name');
    // localStorage.removeItem('user_group');
    localStorage.clear();
  }
}



// WEBPACK FOOTER //
// ./src/services/session-storage.service.ts